/* eslint-disable max-classes-per-file */
import React from 'react';

export const PureRender = <Props extends {}>(
  ComposedComponent: React.ComponentType<Props>
): React.ComponentType<Props> =>
  class extends React.PureComponent<Props> {
    // eslint-disable-line react/prefer-stateless-function
    render() {
      return <ComposedComponent {...this.props} />;
    }
  };

export const onMount =
  <Props extends {}>(initializeFromProps: (p: Props) => void) =>
  (ComposedComponent: React.ComponentType<Props>): React.ComponentType<Props> =>
    class extends React.Component<Props> {
      componentDidMount() {
        initializeFromProps(this.props);
      }

      render() {
        return <ComposedComponent {...this.props} />;
      }
    };
